<template>
	<b-container>
		<b-row align-h="center">
			<b-col>
				<label>Kinek a problémája?</label>
				<b-form-group>
					<b-form-radio v-for="(person, index) in personsAsText" :key="index" v-model="personAsText" :value="person">{{ person }}</b-form-radio>
				</b-form-group>
			</b-col>
		</b-row>
		<b-row>
			<b-col align-self="start">
				<b-button size="sm" variant="outline-info" id="back-button" @click="$router.go(-1)">Vissza</b-button>
			</b-col>
			<b-col align-self="end">
				<b-button variant="info" id="button-to-problems" @click="submit" v-if="personAsText !== null">Tovább a problémákhoz</b-button>
			</b-col>
		</b-row>
	</b-container>
</template>

<script>

import RadioButtons from '@/components/RadioButtons'

export default {
	name: 'person-selector',
	components: {
		RadioButtons
	},
	data() {
		return {
			personOptions: [
				{id:'00001', name: 'hívó'},
				{id:'00002', name: 'házastárs'},
				{id:'00003', name: 'szülő'},
				{id:'00004', name: 'gyerek'},
				{id:'00005', name: 'rokon (testvér, családtag, hozzátartozó'},
				{id:'00006', name: 'partner, élettárs'},
				{id:'00007', name: 'barát, ismerős (pl. partner rokonai)'},
				{id:'00008', name: 'munkatárs'},
				{id:'00009', name: 'hivatalos személy'},
				{id:'00000', name: 'egyéb személy'},
			],
			personAsText: null,
			selectedPerson: {}
		}
	},
	computed: {
		personsAsText() {
			return this.personOptions.map(person => {
				return person.id + ' ' + person.name
			});
		}
	},
	methods: {
		submit(event) {
			if (this.personAsText == null)
				return

			const person = this.personOptions.find(personOption => { return (personOption.id + ' ' + personOption.name) == this.personAsText })
			this.$router.push({ name: 'ProblemSelector', params : { person }})
		}
	},
}
</script>

<style scoped>
	.problems {
		padding: 2em 0;
	}
</style>